/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Review.Api
 * OpenAPI spec version: 1.0
 */

export type ReviewFormDataType = (typeof ReviewFormDataType)[keyof typeof ReviewFormDataType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewFormDataType = {
    Pdf: 'Pdf',
    Html: 'Html',
    Text: 'Text',
    Table: 'Table',
} as const;
